import useScrollAnimation from '@/hooks/useScrollAnimation';

const courses = [
  {
    name: '湯の華スタンダードコース',
    duration: '90分',
    price: '15,000',
    description: 'オイルコース。首・肩・背中・腰・脚までしっかりとケアし日頃の疲れやストレスを癒すスタンダードコースとなります。',
    color: 'primary',
    icon: 'ri-star-line',
  },
  {
    name: '湯の華ストレッチコース',
    duration: '90分',
    price: '14,000',
    description: 'タイ古式コース。指圧・ストレッチを組み合わせて全身をゆっくりと伸ばしていくのが特徴のタイ古式です。※シャワー無し',
    color: 'accent',
    icon: 'ri-body-scan-line',
  },
  {
    name: '湯の華贅沢コース',
    duration: '160分',
    price: '23,000',
    description: 'タイ古式＋オイルコース。トリートメントを贅沢に長時間かけて身体を揉みほぐすロングコースになります。',
    color: 'secondary',
    icon: 'ri-vip-crown-line',
  },
];

export default function MenuSection() {
  const { ref, isVisible } = useScrollAnimation();

  const handleCall = () => {
    window.location.href = 'tel:07077860873';
  };

  return (
    <section id="menu" className="relative py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div
        ref={ref}
        className={`max-w-5xl mx-auto transition-all duration-1000 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="text-center mb-16">
          <p className="text-primary-500 font-sans text-xs tracking-[0.4em] mb-4">
            MENU
          </p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-800 mb-3 tracking-wider">
            人気メニュー
          </h2>
          <div className="w-12 h-[1px] bg-secondary-400 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {courses.map((course, index) => (
            <div
              key={course.name}
              className="group relative bg-background-50 rounded-lg p-8 transition-all duration-500 hover:-translate-y-1"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className={`w-12 h-12 mb-6 flex items-center justify-center rounded-full ${
                course.color === 'primary' ? 'bg-primary-100/70' :
                course.color === 'accent' ? 'bg-accent-100/70' :
                'bg-secondary-100/70'
              } transition-all duration-300 group-hover:scale-110`}>
                <i className={`${course.icon} text-xl ${
                  course.color === 'primary' ? 'text-primary-500' :
                  course.color === 'accent' ? 'text-accent-500' :
                  'text-secondary-500'
                }`}></i>
              </div>

              <h3 className="font-heading text-base md:text-lg text-foreground-800 mb-2 tracking-wide">
                {course.name}
              </h3>

              <p className="text-foreground-500 text-xs tracking-wider mb-4">
                {course.duration}
              </p>

              <div className="flex items-baseline gap-1 mb-6">
                <span className="text-foreground-600 text-xs">¥</span>
                <span className={`font-heading text-2xl md:text-3xl ${
                  course.color === 'primary' ? 'text-primary-600' :
                  course.color === 'accent' ? 'text-accent-600' :
                  'text-secondary-600'
                }`}>
                  {course.price}
                </span>
                <span className="text-foreground-500 text-xs">（税込）</span>
              </div>

              <p className="text-foreground-600 text-xs leading-relaxed mb-8">
                {course.description}
              </p>

              <div className={`w-full h-[1px] mb-6 ${
                course.color === 'primary' ? 'bg-primary-200' :
                course.color === 'accent' ? 'bg-accent-200' :
                'bg-secondary-200'
              }`}></div>

              <button
                onClick={handleCall}
                className={`whitespace-nowrap cursor-pointer w-full py-3 rounded-full text-xs font-sans tracking-wider transition-all duration-300 ${
                  course.color === 'primary'
                    ? 'bg-primary-500 hover:bg-primary-600 text-background-50'
                    : course.color === 'accent'
                    ? 'bg-accent-500 hover:bg-accent-600 text-background-50'
                    : 'bg-secondary-500 hover:bg-secondary-600 text-background-50'
                }`}
              >
                <i className="ri-phone-line mr-1"></i>
                このコースを予約
              </button>
            </div>
          ))}
        </div>

        <p className="md:text-center text-foreground-500 text-xs mt-10">
          ※ 表示価格はすべて税込です。最新の空き状況はお電話にてご確認ください。
        </p>
      </div>
    </section>
  );
}